import React from "react";

const PlayIcon = (props) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="14"
			height="17"
			viewBox="0 0 14 17"
			fill="none"
			{...props}>
			<path
				d="M13.2968 10.008C13.2214 10.0853 12.937 10.416 12.672 10.688C11.1185 12.3987 7.06589 15.1987 4.94477 16.0533C4.62264 16.1907 3.80822 16.4813 3.37309 16.5C2.95613 16.5 2.55867 16.404 2.17939 16.2093C1.70658 15.9373 1.3273 15.5093 1.11947 15.004C0.985686 14.6533 0.77786 13.604 0.77786 13.5853C0.570034 12.4373 0.455729 10.572 0.455729 8.51067C0.455729 6.54666 0.570034 4.75733 0.740192 3.592C0.759675 3.57333 0.967502 2.26933 1.19481 1.82267C1.61176 1.00667 2.42618 0.499999 3.29775 0.499999L3.37309 0.499999C3.94071 0.519999 5.13441 1.02667 5.13441 1.04533C7.14123 1.90133 11.1003 4.564 12.6915 6.33333C12.6915 6.33333 13.1396 6.788 13.3344 7.072C13.6384 7.48 13.7891 7.98533 13.7891 8.49067C13.7891 9.05467 13.6189 9.58 13.2968 10.008Z"
				fill="#EEF3F7"
			/>
		</svg>
	);
};

export default PlayIcon;
